import { NotificationService } from './services/notification.service';
import { LoaderComponent } from './shared/loader/loader.component';
import { ToastMessage } from './shared/toast/toast.component';
import { AppStateProvider } from './services/app-state.provider';
import { ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, ViewChild } from '@angular/core';
import { LoaderExcludes } from './config/api.constant';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppConstant } from './config/app.constant';
import { CommonService } from './services/common.service';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { BehaviorSubject, Observable } from 'rxjs';
import { Location } from '@angular/common';

import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType, InteractionType } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AdalapiService } from './services/adalapi.service';
import { environment } from 'src/environments/environment';
import { SecureStorageService } from './services/secure-storage.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {

  title = 'capitaland';
  url: string;
  accessToken: any;
  token_type: any;
  isLoggedIn: boolean = false;
  @ViewChild(ToastMessage, { static: false }) toastRef: ToastMessage;
  public LoaderComponent = LoaderComponent;
  public LoaderExcludes = LoaderExcludes;
  showSidebar: boolean = false;
  hideFooter: boolean = false;
  adminId: string | null = null;
  tokenCheck: string | null = null;
  isLoggedTokenSaved$ = new BehaviorSubject<boolean>(false);
  token;
  intervalId;

  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  tokens: any;
  capitalLogin: boolean = true;
  currentPath: string;
  messages: string[];

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, // newly added
    private authService: MsalService, // newly added
    private msalBroadcastService: MsalBroadcastService, // newly added
    private appStateSrv: AppStateProvider,
    private commonService: CommonService,
    // private adalSrv: MsAdalAngular6Service,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private notificationSrv: NotificationService,
    private adalapiService: AdalapiService,
    private location: Location,
    private secureStorage: SecureStorageService
  ) {
    localStorage.setItem('checkPage', '0');
    this.adminId = this.secureStorage.getItem('claAdminId');
    this.tokenCheck = this.secureStorage.getItem('token');
    this.route.url.subscribe(() => {
      if (
        window.location.pathname.includes('feedback') ||
        window.location.pathname.includes('terms-condition')
      )
        this.showSidebar = false;
      else this.showSidebar = true;
    });
    this.hideFooter =
      window.location.pathname.includes('terms-condition') ||
      window.location.pathname.includes('vmsGuest') ||
      window.location.pathname.includes('verifyemail') ||
      this.appStateSrv.isMobileDevice();

    // For server
    // if (this.adalSrv.isAuthenticated) {
    //   this.getAdminForCheckinToken();
    // }
    this.authService.instance.enableAccountStorageEvents();
    // For local
    if (this.adminId) {
      this.getAdminForCheckinToken();
    }
  }
  ngOnInit() {

    setTimeout(() => {
      this.adminId = this.secureStorage.getItem('claAdminId');

      this.appStateSrv.toastMessage.subscribe((message) => {

        if (message == 'Session Expired.Try Again' || message == 'Session Expired' || message == 'Session Expired.' || message == 'Token expired.' || message == 'Invalid token.' || message == 'The value \'null\' is not valid.' || message == 'Invalid token' || message == 'The value \'null\' is not valid' || message == 'Session expired, please login again.' || message == 'Session expired, please login again') {
          this.secureStorage.clear();
          this.logoutFromCla();
        }
        if (message) this.toastRef.showToastMessage(message);
      });

      this.setLoginDisplay();

    }, 1000);


    let redirectType = this.secureStorage.getItem('redirectType');
    if (redirectType != null) {
      this.currentPath = this.location.path();
      //this.router.navigate([window.location.pathname]);
      this.router.navigateByUrl(this.currentPath);
      return;
    }

    this.checkingBroadcastServiceAdal();
  }

  checkMessage(message) {
    const regex = /^(Token expired\.|Invalid token\.|The value 'null' is not valid\.)$/;
    return regex.test(message);
  }

  async checkingBroadcastServiceAdal() {
    // newly added
    // this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = environment.domain + '/'; // "http://localhost:4200/";
        } else {
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });
    // newly added
  }

  refreshLocationApi() {
  }

  checkLoginSSO() {
    // return this.adalSrv.isAuthenticated;
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    // newly added
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  getAdminForCheckinToken_BKPOLD() {
    const emailAddress = this.secureStorage.getItem('loginemailaddress');
    const userType = this.secureStorage.getItem('userType');
    this.commonService.getAdminTokenInOverviewPage(emailAddress ?? '').subscribe(() => {
      this.isLoggedTokenSaved$.next(true);
      const tokens = JSON.parse(this.secureStorage.getItem('Tokens') ?? 'null');
      if (userType == 'Bridge+') {
        this.commonService.setTokenAfterSelectionForOverViewPage(tokens?.[1] ?? tokens?.[0]);
      } else {
        this.commonService.setTokenAfterSelectionForOverViewPage(tokens?.[0]);
      }
    });
  }

  getAdminForCheckinToken() {
    const userType = this.secureStorage.getItem('userType');
    this.isLoggedTokenSaved$.next(true);
    const tokens = JSON.parse(this.secureStorage.getItem('Tokens') ?? 'null');
    if (userType == 'Bridge+') {
      this.commonService.setTokenAfterSelectionForOverViewPage(tokens?.[1] ?? tokens?.[0]);
    } else {
      // New api for parkite
      this.commonService.setTokenAfterSelectionForOverViewPage(tokens?.[0]);
    }
  }

  // newly added
  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */

    let activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount == null) {
      let accounts = this.authService.instance.getAllAccounts();
      if (accounts.length > 0) {
        this.secureStorage.setItem('userEmail', accounts[0].username);
        this.authService.instance.setActiveAccount(accounts[0]);
      }
    }
    this.getAccessToken();
  }

  async getAccessToken() {
    try {
      let account = this.authService.instance.getAllAccounts();
      const response = this.authService.acquireTokenSilent({
        scopes: ['https://graph.microsoft.com/User.Read'],
        account: account[0]
      }).subscribe((token) => {
        this.appStateSrv.setLoginStatus(true);
        this.secureStorage.setItem('adalAccessToken', token.accessToken);
        this.commonService.getAdminTokenAdalAuth(token.accessToken).subscribe(r => {
          if (r.isValid == false) {
            this.logoutFromCla();
            // this.router.navigateByUrl("");
          } else {
            this.tokens = JSON.parse(this.secureStorage.getItem('Tokens') ?? 'null');
            this.appStateSrv.getLoginStatus().subscribe((status: boolean) => {
              this.isLoggedIn = status;
              this.cdr.detectChanges();
            });
            this.router.navigate(['/auth/']);
          }
        });
      });
    } catch (error) {
      localStorage.clear();
      this.logoutFromCla();
    }
  }

  logoutFromCla() {
    setTimeout(() => {
      this.logoutFromAd();
    }, 1000);
  }

  logoutFromAd(popup?: boolean) {
    window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURI(environment.domain)}`
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  loginPopup() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({
          ...this.msalGuardConfig.authRequest,
        } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({
          ...this.msalGuardConfig.authRequest,
        } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: environment.domain + '/' // "http://localhost:4200/"
      });
    } else {
      this.authService.logoutRedirect();
    }
  }
}
